var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "189.83mm",
    height: "28.778mm",
    viewBox: "0 0 189.83 28.778",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-109 60h1366v-5989h-1366z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35.111 22.969c0.67687 0 2.0904 0.14124 2.9943 1.3842 1.0159 1.3842 1.1571 3.418 1.1571 4.435 0 2.5424-0.76271 5.1988-3.8983 5.1988-4.2372 0-4.2372-4.4926-4.2372-5.7638 0-1.7232 0.25423-5.2542 3.9841-5.2542zm-6.5265 10.453c0 0.62038-0.02825 0.96045-0.08475 2.3164h2.6847l0.05541-2.3446c1.3277 2.2305 3.6723 2.5706 4.8316 2.5706 3.0497 0 5.9604-2.0904 5.9604-7.3457 0-5.2824-3.0802-7.5988-6.4689-7.5988-2.0621 0-3.5886 0.8757-4.3513 2.1186v-7.0338h-2.6271z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-109 60h1366v-5989h-1366z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50.835 23.054c2.0067 0 4.2948 1.4407 4.2948 5.7062 0 3.531-1.6395 5.3965-4.1254 5.3965-1.6938 0-4.435-1.0745-4.435-5.5095 0-2.9096 1.244-5.5932 4.2655-5.5932m0.16949 13.052c5.679 0 6.9502-4.4643 6.9502-7.4304 0-4.1525-2.3446-7.5988-7.1762-7.5988-4.6881 0-6.9774 3.2486-6.9774 7.4011 0 3.5028 1.6384 7.6281 7.2033 7.6281",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-109 60h1366v-5989h-1366z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62.353 25.766c-0.02824-1.0734 0.53672-2.5706 3.1073-2.5706 1.1017 0 1.9209 0.19774 2.4848 0.90395 0.28358 0.36723 0.45198 0.84745 0.45198 1.3277 0 1.3842-0.98761 1.6384-3.1062 2.1186-2.9661 0.67796-5.4519 1.2712-5.4519 4.2372 0 2.5999 2.2599 4.2938 5.5367 4.2938 1.7796 0 4.2655-0.50847 5.113-2.2034 0.36723-0.79095 0.36723-1.4689 0.36723-2.0621h-2.7118c0.08475 2.148-1.7796 2.3164-2.7401 2.3164-0.39548 0-2.8824 0-2.8824-2.0339 0-1.2994 1.2723-1.6102 2.0067-1.8079 3.9265-0.9322 4.774-1.1582 5.6214-1.9491 0.79096-0.73445 1.0734-1.7232 1.0734-2.6271 0-1.5819-0.8757-2.9378-1.9209-3.5875-1.2429-0.76271-2.7401-0.96044-4.2101-0.96044-2.8802 0-5.5649 1.1864-5.5356 4.6045z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-109 60h1366v-5989h-1366z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m72.022 35.794h2.5141v2.9661l2.6271 0.84745v-3.8135h3.1638v-1.9491h-3.1638v-8.5028c0-0.7073 0-1.8926 1.8926-1.8926 0.53563 0 1.0452 0.08474 1.2712 0.14124v-2.0621c-0.48022-0.08475-1.2429-0.17058-2.2034-0.17058-2.4294 0-3.5876 0.70621-3.5876 3.0237v9.4632h-2.5141z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-109 60h1366v-5989h-1366z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m91.369 30.031c0.02825 1.3559-0.22598 4.1808-3.5028 4.1808-1.7232 0-3.8135-1.0452-3.87-4.1808zm-7.4858-1.8644c-0.05649-2.9378 1.1582-5.113 4.0678-5.113 1.7232 0 3.1073 0.90395 3.3333 2.9378h2.6553c-0.08474-0.70621-0.19665-1.8644-1.2147-2.9661-0.62037-0.70621-2.0339-1.8926-4.887-1.8926-4.4632 0-6.5819 2.7683-6.5819 7.2598 0 2.7966 0.56497 5.113 2.7966 6.6666 1.3559 0.96045 3.0508 1.0452 3.87 1.0452 6.357 0 6.2146-5.6214 6.1582-7.9378z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-109 60h1366v-5989h-1366z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m103.83 33.11c-1.7796 0-2.7401-1.6384-2.7401-4.0113 0-1.4972 0.339-3.9548 2.6836-3.9548 2.5424 0 2.6271 2.9943 2.6271 4.0113 0 0.73446 0 3.9548-2.5706 3.9548zm7.8248 2.7118v-13.22c0-1.6949-0.3379-3.7016-2.2598-5.0575-1.2147-0.87462-2.9379-1.5819-5.8474-1.5819-1.6102 0-4.2938 0.22598-5.904 1.6666-1.2429 1.1028-1.2712 2.4304-1.3005 3.1649h5.0011c0.0282-1.0734 0.7909-1.8079 2.3164-1.8079 2.6553 0 2.8248 1.9209 2.8248 3.4463v1.8644c-1.4407-2.1469-3.757-2.2881-4.5773-2.2881-2.9933 0-6.2983 1.8644-6.2983 7.0338 0 3.8418 2.0339 7.0338 6.3558 7.0338 2.7401 0 3.9831-1.2712 4.6904-2.4011v2.1469z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m95.611 15.963h16.045v20.114h-16.045z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-109 60h1366v-5989h-1366z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m119.56 25.313c0.6204-1.0734 1.5819-1.1299 2.0611-1.1299 2.3174 0 2.7694 2.5141 2.7694 4.4915 0 2.4576-0.5943 4.5197-2.7119 4.5197-2.3446 0-2.7965-2.4011-2.7965-4.5197 0-0.9322 0.0847-2.3164 0.6779-3.3616m2.1186 10.905c4.6034 0 8.1921-2.3175 8.1921-7.3457 0-2.0621-0.5932-4.1525-2.0622-5.6214-1.1864-1.1582-2.9378-2.0339-5.8474-2.0339-3.1366 0-5.1705 0.76271-6.5536 2.0904-1.6395 1.5537-2.0339 3.6723-2.0339 5.3954 0 4.3513 2.6825 7.5152 8.305 7.5152",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-109 60h1366v-5989h-1366z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m141.93 38.45c-0.226 0.0565-0.7627 0.16949-1.47 0.16949-2.174 0-2.1175-1.7514-2.0893-2.9378h3.4181v-3.4474h-3.4181v-10.678h-5.1988v10.678h-2.7401v3.4474h2.826c-0.0859 3.3898-0.0294 6.3559 5.5366 6.3559 1.4396 0 2.5424-0.11299 3.1356-0.16949z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m130.43 21.556h11.498v20.481h-11.498z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-109 60h1366v-5989h-1366z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m143 32.715-0.1412 3.0226h5.1695l0.0847-2.9378c1.2147 3.1638 3.7853 3.0791 5.001 3.0508v-4.548c-0.6225 0.05649-0.7637 0.08474-1.1299 0.08474-3.2496 0-3.7016-2.2881-3.7016-3.8135v-6.018h-5.2825z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-109 60h1366v-5989h-1366z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m163.78 30.455c-0.0565 0.8192-0.2259 2.9661-2.5423 2.9661s-2.5141-2.2881-2.5706-2.9661zm-5.1694-2.8813c0-0.7627 0-3.4463 2.7118-3.4463 1.4125 0 2.2882 0.73446 2.4305 2.0621h4.9424c-0.3955-3.5593-3.7288-4.9446-7.4011-4.9446-4.9435 0-7.5988 2.4869-7.5988 7.1762 0 4.7457 2.3163 7.8248 7.5423 7.8248 3.9558 0 5.7909-1.6102 6.7513-3.6158 0.6215-1.2147 0.7921-2.5706 0.7921-5.0565z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-109 60h1366v-5989h-1366z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m174.96 26.161c0-0.25424 0-0.79096 0.226-1.2712 0.1988-0.45198 0.6508-0.8757 1.5547-0.8757 1.2147 0 1.6091 0.8192 1.6091 1.4407 0 0.98869-0.8192 1.2712-2.0057 1.5819l-2.8813 0.8192c-0.8757 0.22599-3.4463 0.93219-3.4463 3.8418 0 1.4124 0.7627 2.5988 1.6949 3.2203 1.2429 0.8757 2.9389 1.2147 5.0293 1.2147 3.0497 0 6.2429-0.8192 6.4689-4.774h-5.0282c0 0.42372 0 0.96044-0.1989 1.3842-0.2259 0.45197-0.6203 0.7627-1.4678 0.7627-0.8192 0-1.5819-0.36723-1.5819-1.2429 0-0.8192 0.5932-1.1299 1.4407-1.3559l3.7842-1.0452c1.3559-0.36723 3.3344-1.1299 3.3344-3.8983 0-4.8033-5.5661-4.8033-6.809-4.8033-2.8802 0-7.0338 0.42481-6.9773 5.001z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-109 60h1366v-5989h-1366z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m185.33 41.952h5.3661v-7.7683c0.5661 0.56497 1.8655 1.8644 4.435 1.8644 1.3853 0 2.7977-0.36723 3.9559-1.4407 1.4124-1.2712 1.4124-2.8248 1.4124-4.8022v-8.2485h-5.2824v7.6271c0 1.1864 0 3.5028-2.2034 3.5028-1.6949 0-2.0915-1.4124-2.2316-1.9774-0.1413-0.64971-0.1413-1.5537-0.1413-2.7401v-6.4124h-5.3107z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m185.33 21.557h15.169v20.395h-15.169z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(120.35 -481.38)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.76569 0 0 .76569 -120.35 481.38)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4414 0 0 -1.4414 -41.081 60.593)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.5 36.964h15.532v-21.86h-15.532z",
    fill: "#0f52a0"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4414 0 0 -1.4414 -41.081 60.593)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42.801 37.105h16.154v-17.029h-16.154z",
    fill: "#0f52a0"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4414 0 0 -1.4414 -41.081 60.593)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.527 37.076h13.696v-16.915h-13.696z",
    fill: "#0f52a0"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4414 0 0 -1.4414 -41.081 60.593)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71.022 40.608h10.305v-20.25h-10.305z",
    fill: "#0f52a0"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4414 0 0 -1.4414 -41.081 60.593)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m80.256 37.105h15.024v-16.972h-15.024z",
    fill: "#0f52a0"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4414 0 0 -1.4414 -41.081 60.593)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m94.611 37.076h18.045v-22.114h-18.045z",
    fill: "#0f52a0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4414 0 0 -1.4414 -41.081 60.593)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m112.37 37.218h18.497v-17.001h-18.497z",
    fill: "#0f52a0"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4414 0 0 -1.4414 -41.081 60.593)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m129.43 43.037h13.498v-22.481h-13.498z",
    fill: "#0f52a0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4414 0 0 -1.4414 -41.081 60.593)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m141.86 36.964h12.255v-16.408h-12.255z",
    fill: "#0f52a0"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4414 0 0 -1.4414 -41.081 60.593)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m152.7 37.246h17.086v-17.001h-17.086z",
    fill: "#0f52a0"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4414 0 0 -1.4414 -41.081 60.593)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m168.65 37.133h15.843v-16.973h-15.843z",
    fill: "#0f52a0"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4414 0 0 -1.4414 -41.081 60.593)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m184.33 42.952h17.169v-22.395h-17.169z",
    fill: "#0f52a0"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7925c620424e94dea0465a1837fc023a.svg";
export { ForwardRef as ReactComponent };